import type {
  CheckoutPrice,
  Product,
  SectionProductDetail
} from '@space-shell/common/services/sections'
import {
  getProductPrice,
  getProductActivePrice
} from '@space-shell/modules/products/utils/productCoupon'
import {
  isSubscriptionPlan,
  getSubscriptionPrice
} from '@space-shell/modules/products/utils/subscriptionProduct'

type UseGetProductPriceProps = {
  product: SectionProductDetail | Product
  language: string
  purchased: boolean | undefined
}

type SubscriptionPrice = {
  currency?: string
  discountedPrice?: {
    coupon: number
    fullPrice: string
  }
  fullPrice: string
  price?: string
}

type UseGetProductPriceResponse = {
  checkoutPrice: SubscriptionPrice | CheckoutPrice | null
  price: string | null | undefined
  showPrice: boolean
}

const useGetProductPrice = ({
  product,
  language,
  purchased
}: UseGetProductPriceProps): UseGetProductPriceResponse => {
  const isSubscriptionPlanActive = isSubscriptionPlan(product)
  const checkoutPrice = isSubscriptionPlanActive
    ? getSubscriptionPrice(product, language)
    : getProductPrice(product, language)
  const productPriceActive = getProductActivePrice(isSubscriptionPlanActive, checkoutPrice)
  const showPrice = Boolean(productPriceActive && !purchased)

  return {
    checkoutPrice,
    price: productPriceActive || product?.price,
    showPrice
  }
}

export default useGetProductPrice
